import { BehaviorSubject } from 'rxjs';
import { useState, useEffect } from 'react';

// the currently active client (or the last active client!)
export const currentClient = new BehaviorSubject(null);

// should an application need access to the current client, this hook
// is how to obtain it.
export function useCurrentClient() {
    const [client, setClient] = useState(currentClient.getValue());

    useEffect(() => {
        const observer = currentClient.subscribe(client => setClient(client));
        return () => observer.unsubscribe();
    }, [setClient]);

    return client;
}
